module.exports = __webpack_public_path__ + "media/images/icons/chart-up-outline-891a5749d78c6adf180f5119223fd049.svg";